import { useEffect, useState } from 'react'
import { IGigyaAccount } from '../contexts/authContext';
import { getUserData, login } from '../utils/gigya';


declare global {
	// eslint-disable-next-line no-unused-vars
	interface Window {
		gigya?: any;
	}
}

const useAuth = () => {

	const [auth, setAuth] = useState<IGigyaAccount | null>(null);
	const [isAuthenticated, setIsAuthenticated] = useState(false)
	const [loading, setLoading] = useState(true);

	const setAuthData = () => {
		setLoading(true);
		getUserData().then((res: any) => {
			setAuth(prev => {
				setLoading(false);
				sessionStorage.setItem('mentoria-uid', res.UID)
				return res
			})
			setIsAuthenticated(true);
		})
	}

	const setLogoutAuth = () => {
		sessionStorage.removeItem('mentoria-uid');
		sessionStorage.removeItem('mentoria-token');
		setAuth(null)
		setIsAuthenticated(false);
	}

	useEffect(() => {
		if (typeof window !== 'undefined' && typeof window.gigya !== 'undefined') {
			window.gigya.socialize.addEventHandlers({
				onLogin: setAuthData,
				onLogout: setLogoutAuth,
				onError: setLogoutAuth,
			});
		}
		getUserData()
			.then((res: any) => {
				setIsAuthenticated(true);
				sessionStorage.setItem('mentoria-uid', res.UID)
				setAuth(res);
			})
			.catch(() => {
				setLogoutAuth();
				login();
			})
			.finally(() => {
				setLoading(false);
			})
	}, [])


	return ({ auth, isAuthenticated, loading });
}

export default useAuth